import { inject, RendererFactory2, DOCUMENT } from '@angular/core';
import { takeWhileAlive } from '@core/frontend-shared';
import { AccessibilityThemeService } from '../theme-service';
import * as i0 from "@angular/core";
export let AccessibilityDarkModeHandler = /*#__PURE__*/(() => {
  class AccessibilityDarkModeHandler {
    constructor() {
      this.themeService = inject(AccessibilityThemeService);
      this.doc = inject(DOCUMENT);
      this.renderer = inject(RendererFactory2).createRenderer(null, null);
      this.themeService.currentTheme$.pipe(takeWhileAlive()).subscribe(themeName => this.renderer.setAttribute(this.doc.body, 'ui-theme', themeName));
    }
    onUpdate(enabled, config) {
      this.themeService.updateConfig({
        enabled,
        config
      });
    }
    static {
      this.ɵfac = function AccessibilityDarkModeHandler_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AccessibilityDarkModeHandler)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: AccessibilityDarkModeHandler,
        factory: AccessibilityDarkModeHandler.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AccessibilityDarkModeHandler;
})();